import { Component, h, Element, Host } from '@stencil/core';
import { getCurrentBreakpoint, isBreakpointBetween, isBreakpointLarger } from '../../../utils';

@Component({
  tag: 'dc-ui-web-stage-item',
  styleUrl: 'dc-ui-web-stage-item.scss',
  shadow: true,
})
export class DcUiWebStageItem {
  @Element() el: HTMLElement;
  image: HTMLElement;
  headline: HTMLElement;
  copy: HTMLElement;
  cta: HTMLElement;

  private imageOnly = false;

  componentWillLoad() {
    this.image = this.el.querySelector('[slot="image"] img');
    this.headline = this.el.querySelector('[slot="headline"]');
    this.copy = this.el.querySelector('[slot="copy"]');
    this.cta = this.el.querySelector('[slot="cta"]');

    this.imageOnly = !this.headline && !this.copy && !this.cta;

    window.addEventListener('resize', () => {
      this.adjustImage();
      this.adjustTexts();
      this.adjustCTA();
    });

    this.adjustImage();
    this.adjustTexts();
    this.adjustCTA();
  }

  adjustImage = () => {
    this.image.style.objectFit = 'cover';
    this.image.style.width = '100%';
    this.image.style.height = '100%';
    this.image.style.aspectRatio = isBreakpointLarger('xl') ? (this.imageOnly ? '90 / 31' : '16 / 9') : '16 / 9';
  };

  adjustTexts = () => {
    if (isBreakpointLarger('xxl')) {
      this.adjustVariant(this.headline, 'DC-UI-HEADLINE', 'h1');
      this.adjustVariant(this.copy, 'DC-UI-TEXT', 'intro-text');
    } else {
      this.adjustVariant(this.headline, 'DC-UI-HEADLINE', getCurrentBreakpoint() === 'lg' ? 'h3' : 'h2');
      this.adjustVariant(this.copy, 'DC-UI-TEXT', 'text');
    }
  };

  adjustCTA = () => {
    if (isBreakpointBetween('lg', 'xl')) {
      this.adjustVariant(this.cta, 'DC-UI-LINK-BUTTON', 'small', 'size');
    } else {
      this.adjustVariant(this.cta, 'DC-UI-LINK-BUTTON', 'normal', 'size');
    }
  };

  adjustVariant = (element: HTMLElement, nodeName: string, variant: string, propName = 'variant') => {
    if (element && element.nodeName === nodeName) {
      element.setAttribute(propName, variant);
    }
  };

  render() {
    return (
      <Host>
        <div class={{ 'container': true, 'image-only': this.imageOnly }}>
          <div class="image-wrapper">
            <slot name="image" />
          </div>
          {!this.imageOnly && (
            <div class="content-wrapper">
              {this.headline && (
                <div class="headline-wrapper">
                  <slot name="headline" />
                </div>
              )}
              {this.copy && (
                <div class="copy-wrapper">
                  <slot name="copy" />
                </div>
              )}
              {this.cta && (
                <div class="cta-wrapper">
                  <slot name="cta" />
                </div>
              )}
            </div>
          )}
        </div>
      </Host>
    );
  }
}
